import React from 'react';
import PropTypes from 'prop-types';

import messages from './messages';
import WebsiteComponent from './components/websiteComponent';

import '../styles.css';

const Website = ({ onChange, initialValue, formatMessage }) => (
  <WebsiteComponent
    name="Transfer"
    value={initialValue.value}
    onChange={onChange}
    stylesName="transfer-website-container"
    placeholder={formatMessage(messages.websitePlaceholder)}
    subheading={formatMessage(messages.transferWebsiteLabel)}
    showError={initialValue.showError}
  />
);

Website.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default Website;
